/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FileUploadResponseDto = {
  /**
   * File Upload Link
   */
  link?: string;
  /**
   * File Upload Link HTTP Method
   */
  method?: FileUploadResponseDto.method;
  /**
   * File Upload Link Expiration Date
   */
  expiresAt?: string;
  /**
   * Required meta attributes
   */
  metaAttributes?: Array<string>;
};
export namespace FileUploadResponseDto {
  /**
   * File Upload Link HTTP Method
   */
  export enum method {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    HEAD = 'HEAD',
    PATCH = 'PATCH',
    OPTIONS = 'OPTIONS',
  }
}

